import { Link } from "react-router-dom";
import styled from "styled-components";

const SkilledDevelopers = () => {
  return (
    <StyledSkilledDevelopers className="">
      <div className="section_wrapper home_parent_wrapper">
        <div className="content_wrapper">
          <h3>
            Developers on <span>Profiles</span> are highly skilled
          </h3>
          <div className="view-profile">
            <Link to={"/devlist"} className="">
              See more Profiles
            </Link>
          </div>
        </div>
        <div className="img_gallery_wrapper">
          <div className="img_gallery">
            <div className="img_wrapper">
              <img
                src="/images/decadev_one.svg"
                alt="Decadev"
                width={203}
                height={237}
              />
            </div>
            <div className="img_wrapper">
              <img
                src="/images/decadev_two.svg"
                alt="Decadev"
                width={203}
                height={237}
              />
            </div>
          </div>
          <div className="img_gallery">
            <div className="img_wrapper">
              <img
                src="/images/decadev_three.svg"
                alt="Decadev"
                width={203}
                height={237}
              />
            </div>
            <div className="img_wrapper">
              <img
                src="/images/decadev_four.svg"
                alt="Decadev"
                width={203}
                height={237}
              />
            </div>
          </div>
          <div className="img_gallery stretched_section">
            <div className="img_wrapper stretched_img">
              <img
                src="/images/decadev_five.svg"
                alt="Decadev"
                width={292}
                height={352}
              />
            </div>
            <Link className="many_more" to="/devlist">
              <span>And many more</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </StyledSkilledDevelopers>
  );
};

const StyledSkilledDevelopers = styled.div`
  margin: 8rem 0;
  background: #ecfdff;
  .section_wrapper {
    padding: 8rem 0;
    display: grid;
    grid-template-columns: 1fr 1.7fr;
    gap: 10.7rem;
  }

  .content_wrapper h3 {
    font-size: 5.8rem;
    font-weight: 700;
    line-height: 140%;
    letter-spacing: -0.5px;
    margin-bottom: 3.2rem;
  }

  h3 span {
    color: #34a853;
  }

  .view-profile a {
    font-family: "Inter", sans-serif;
    display: inline-block;
    text-align: center;
    background-color: #34a853;
    font-weight: 600;
    color: #ffffff;
    width: 26.3rem;
    padding: 1.6rem;
    border-radius: 10rem;
    transition: all 0.2s ease-in-out;
  }
  .view-profile a:hover {
    background-color: #2f8a4c;
    text-decoration: none;
  }
  .view-profile a:active {
    opacity: 0.8;
  }

  .img_gallery_wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .img_gallery {
    display: grid;
    gap: 8px;
  }

  .stretched_section {
    display: grid;
    grid-template-rows: 352px 1fr;
    gap: 8px;
  }

  .img_gallery img {
    width: 100%;
    object-fit: cover;
    object-position: top;
  }

  .many_more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2.6rem;
    background: #101828;
    height: 100%;
    font-size: 2rem;
    font-weight: 700;
    font-style: italic;
    white-space: nowrap;
    text-decoration: none;
    color: #fff;
  }

  .many_more span {
    margin-right: 3.2rem;
  }

  @media screen and (max-width: 900px) {
    .section_wrapper {
      grid-template-columns: 1fr;
      gap: 4.6rem;
    }

    .img_gallery_wrapper {
      grid-template-columns: repeat(2, 1fr);
    }

    .content_wrapper h3 {
      font-size: 3.2rem;
      margin-bottom: 2.4rem;
    }

    .view-profile a {
      font-family: "Inter", sans-serif;
      display: inline-block;
      text-align: center;
      background-color: #34a853;
      font-weight: 600;
      color: #ffffff;
      width: 26.3rem;
      padding: 1.6rem;
      border-radius: 10rem;
    }

    .stretched_section {
      grid-column: span 2 / span 2;
    }
  }
`;

export default SkilledDevelopers;
